import { useSearchParams } from 'react-router';

import { StyledLink } from '@/components/styled-link';

import {
  AuthTemplate,
  FooterLinks,
} from '@/pages/unauthenticated/auth/components';
import { AppEnvMap } from '@/core/app-env';

import { LoginSection } from './login-section';

export default function Login() {
  const [searchParams] = useSearchParams();

  const cliCode = searchParams.get('cliCode') ?? undefined;
  const redirectUri = searchParams.get('redirectUri') ?? undefined;

  const url = new URL(`${AppEnvMap.BaseUrl}/auth/google`);
  if (cliCode && redirectUri) {
    url.searchParams.append('cliCode', cliCode);
    url.searchParams.append('redirectUri', redirectUri);
  }
  const googleAuthUrl = url.toString();

  const showOAuth = import.meta.env.VITE_ENABLE_OAUTH === 'true';

  return (
    <AuthTemplate
      className="px-2 sm:px-0 mt-8 lg:mt-0"
      heading="Sign in to your account"
      subheading={<LoginSubheading />}
      footer={<FooterLinks />}
    >
      <LoginSection
        cliCode={cliCode}
        redirectUri={redirectUri}
        googleAuthUrl={googleAuthUrl}
        showOAuth={showOAuth}
      />
    </AuthTemplate>
  );
}

function LoginSubheading() {
  return (
    <span>
      Not a member?{' '}
      <StyledLink href="/register">Start a 14 day free trial</StyledLink>
    </span>
  );
}
